module.exports = __webpack_public_path__ + "img/16.80ee0d76.png";